import { render } from "./PageTitleComponent.vue?vue&type=template&id=3f674226&scoped=true"
import script from "./PageTitleComponent.vue?vue&type=script&lang=js"
export * from "./PageTitleComponent.vue?vue&type=script&lang=js"

import "./PageTitleComponent.vue?vue&type=style&index=0&id=3f674226&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f674226"]])

export default __exports__